export default "__VITE_ASSET__43c63f1d__"